<template>
    <div v-if="loading">
        <el-skeleton :rows="2" animated />
    </div>

    <el-empty v-else-if="!liitteet || liitteet.length === 0" description="Ei liitteitä" :image-size="60" />

    <el-table v-else :data="liitteet" size="small" class="tilat-table" style="width: 100%">
        <el-table-column label="Liitteet" show-overflow-tooltip>
            <template #default="scope">
                <el-space :size="8">
                    <el-icon color="var(--el-text-color-secondary)">
                        <Document />
                    </el-icon>
                    <span>{{ scope.row.nimi || scope.row.tiedosto }}</span>
                </el-space>
            </template>
        </el-table-column>
        <el-table-column width="50" align="center">
            <template #default="scope">
                <ComDownloadButton @click="() => $emit('downloadLiite', scope.row.id)" />
            </template>
        </el-table-column>
    </el-table>
</template>

<script setup lang="ts">
import { Document } from "@element-plus/icons-vue"
import ComDownloadButton from "@/components/common/buttons/ComDownloadButton.vue"
import { LiiteResponse } from "@/api/models/liite-response"

defineProps<{
    liitteet: LiiteResponse[] | undefined
    loading: boolean
}>()

defineEmits<{
    downloadLiite: [id: number]
}>()
</script>

<style scoped>
.tilat-table {
    border-radius: 4px;
    overflow: hidden;
}

.tilat-table :deep(.el-table__header) {
    background-color: #f5f7fa;
}
</style>